import { motion } from "framer-motion";
import { SERVICES } from "@/lib/constants";

const reveal = {
  hidden: { opacity: 0, y: 28 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-white py-16 sm:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 sm:gap-8 mb-12 sm:mb-20">
          <div className="max-w-2xl">
            <p className="overline mb-4 sm:mb-5 text-[10px] sm:text-xs">
              <span className="inline-block w-8 sm:w-10 h-px bg-[#D4AF37] align-middle mr-3 sm:mr-4" />
              For boligejere · Hvad vi hjælper med
            </p>
            <h2
              className="font-serif text-[2.25rem] sm:text-5xl lg:text-6xl text-[#111111] font-light tracking-tight leading-[1.05]"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              Hotelstandard på din{" "}
              <span className="italic text-[#C9A227]">korttidsudlejning</span> -
              uden du løfter en finger.
            </h2>
          </div>
          <p className="max-w-md text-base sm:text-lg text-[#555555] font-light leading-relaxed">
            Fra første gæstebesked til sidste check-out tager vi hånd om alle
            detaljer, der gør forskellen mellem et godt og et exceptionelt
            ophold.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 sm:gap-8">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.id}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              variants={reveal}
              data-testid={`service-card-${s.id}`}
              className={`service-card ${s.span} h-[360px] sm:h-[480px] lg:h-[520px]`}
            >
              <div
                className="service-image"
                style={{ backgroundImage: `url(${s.image})` }}
              />
              <div className="service-content absolute inset-0 flex flex-col justify-between p-7 sm:p-10 lg:p-12">
                <div className="flex items-center justify-between">
                  <span className="text-[10px] sm:text-xs tracking-[0.25em] sm:tracking-[0.3em] uppercase text-[#D4AF37]">
                    0{i + 1} / 04
                  </span>
                  <span className="h-px w-10 sm:w-12 bg-white/30" />
                </div>
                <div>
                  <h3
                    className="font-serif text-2xl sm:text-4xl lg:text-[2.75rem] text-white font-light leading-tight"
                    style={{ fontFamily: "Fraunces, serif" }}
                  >
                    {s.title}
                  </h3>
                  <p className="mt-3 sm:mt-4 max-w-md text-white/85 font-light text-sm sm:text-base leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
